import React, { useMemo } from 'react'
import { orderPointsListItemsFrom } from './orderPointsListBackend'
import { OrderPointListItem } from './OrderPointListItem'

export function OrderPointsList ({ order, expandPointsList, previousOrder }) {
  const items = useMemo(() => orderPointsListItemsFrom(
    order.loadingDeliveryPoints,
    order.unloadingDeliveryPoints,
    order.intermediatePoints
  ), [order])

  const previousItems = useMemo(() =>
    previousOrder ? orderPointsListItemsFrom(
      previousOrder.loadingDeliveryPoints,
      previousOrder.unloadingDeliveryPoints,
      previousOrder.intermediatePoints
    ) : [], [previousOrder])
  return (
    <>
      {
        new Array(Math.max(items.length, previousItems.length))
          .fill(1)
          .map((_, index) =>
            <OrderPointListItem
              key={index}
              item={items[index]}
              previousItem={previousOrder && { value: previousItems[index] }}
              defaultExpanded={expandPointsList}/>)
      }
    </>
  )
}
